import DataObject from './DataObject';

import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

export default class MultiDataObject extends DataObject {
  constructor(metadataRules) {
    super(metadataRules);

    this.dtoPropertyNameField = null;
    this.dtoPropertyValueField = null;
    this.dtoSecondaryPropertyNames = [];
  }

  useDynamicSchema() {
    return true;
  }

  useInheritedMetadataRules() {
    return true;
  }

  getDtoSchema() {
    return null;
  }

  initDataObject(dtoObjects) {
    if (CoreUtils.isUndefinedOrNull(dtoObjects))
      return;

    if (CoreUtils.isUndefinedOrNull(dtoObjects) || !Array.isArray(dtoObjects))
      return;

    this.dispose();
    this.isNew = false;

    this.processMultiDataSchema();
    if (!this.isMultiDataSchemaDefined())
      return;

    var pseudoDtoObject = {};
    dtoObjects.forEach(dtoObject => {
      var propertyName = dtoObject[this.dtoPropertyNameField];
      var propertyValue = dtoObject[this.dtoPropertyValueField];
      pseudoDtoObject[propertyName] = propertyValue;

      this.dtoSecondaryPropertyNames.forEach(secondaryPropertyName => {
        var fullPropertyName = MultiDataObject.getSecondaryPropertyName(
          propertyName,
          secondaryPropertyName
        );
        this[fullPropertyName] = dtoObject[secondaryPropertyName];
      });
    });

    this.processPropertyValues(pseudoDtoObject);
  }

  createDataObject() {
    this.dispose();
    this.isNew = true;

    this.processMultiDataSchema();
    if (!this.isMultiDataSchemaDefined())
      return;

    this.processPropertyValues(null);
  }

  getDtoObject(modifiedPropertiesOnly) {
    if (!this.isMultiDataSchemaDefined())
      return [];

    var primaryPropertyNames = this.propertyNames;
    if (modifiedPropertiesOnly)
      primaryPropertyNames = this.getModifiedPropertyNames();

    var baseDtoObject = super.getDtoObject();

    var dtoObjects = [];
    primaryPropertyNames.forEach(primaryPropertyName => {
      var dtoObject = {};

      dtoObject[this.dtoPropertyNameField] = primaryPropertyName;
      dtoObject[this.dtoPropertyValueField] = baseDtoObject[primaryPropertyName];

      this.dtoSecondaryPropertyNames.forEach(secondaryPropertyName => {
        var fullPropertyName = MultiDataObject.getSecondaryPropertyName(
          primaryPropertyName,
          secondaryPropertyName
        );

        dtoObject[secondaryPropertyName] = this[fullPropertyName];
      });

      dtoObjects.push(dtoObject);
    });

    return dtoObjects;
  }

  getState() {
    var state = super.getState();

    this.propertyNames.forEach(primaryPropertyName => {
      this.dtoSecondaryPropertyNames.forEach(secondaryPropertyName => {
        var fullPropertyName = MultiDataObject.getSecondaryPropertyName(
          primaryPropertyName,
          secondaryPropertyName
        );

        state[fullPropertyName] = this[fullPropertyName];
      });

    });

    return state;
  }

  commitUpdatedValues(dtoObjects) {
    if (!this.isModified)
      return;

    var state = {};

    var pseudoDtoObject = {};
    dtoObjects.forEach(dtoObject => {
      var propertyName = dtoObject[this.dtoPropertyNameField];
      var propertyValue = dtoObject[this.dtoPropertyValueField];
      pseudoDtoObject[propertyName] = propertyValue;

      this.dtoSecondaryPropertyNames.forEach(secondaryPropertyName => {
        var fullPropertyName = MultiDataObject.getSecondaryPropertyName(
          propertyName,
          secondaryPropertyName
        );

        var value = dtoObject[secondaryPropertyName];
        if (value === this[fullPropertyName])
          return;

        this[fullPropertyName] = value;
        state[fullPropertyName] = value;
      });
    });

    this.notifyStateUpdated(state);
    super.commitUpdatedValues(pseudoDtoObject);
  }

  dispose() {
    this.dtoPropertyNameField = null;
    this.dtoPropertyValueField = null;
    this.dtoSecondaryPropertyNames = [];

    super.dispose();
  }

  processMultiDataSchema() {
    var dtoSchema = this.getDtoSchema();
    if (CoreUtils.isUndefinedOrNull(dtoSchema))
      return;

    this.dtoPropertyNameField = dtoSchema.propertyNameField;
    this.dtoPropertyValueField = dtoSchema.propertyValueField;
    this.dtoSecondaryPropertyNames = dtoSchema.secondaryPropertyNames;

    if (!this.isMultiDataSchemaDefined()) {

      this.dtoPropertyNameField = null;
      this.dtoPropertyValueField = null;
      this.dtoSecondaryPropertyNames = [];
      return;
    }

    if (!StringUtils.isStringArray(this.dtoSecondaryPropertyNames))
      this.dtoSecondaryPropertyNames = [];
  }

  isMultiDataSchemaDefined() {
    return (!StringUtils.isNullOrWhitespace(this.dtoPropertyNameField)
      && !StringUtils.isNullOrWhitespace(this.dtoPropertyValueField));
  }

  static getSecondaryPropertyName(primaryPropertyName, secondaryPropertyName) {
    return `${primaryPropertyName}_${secondaryPropertyName}`;
  }
}